import { render } from "./MR.vue?vue&type=template&id=45a837a4"
import script from "./MR.vue?vue&type=script&lang=js"
export * from "./MR.vue?vue&type=script&lang=js"

import "./MR.vue?vue&type=style&index=0&id=45a837a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__